import React from "react";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../../config";

const BlogCard = ({ data, mobile }) => {
  if (mobile) {
    return (
      <Link to={"/blogs/" + data?.url}>
        <img
          src={CDN_BASE_URL + data?.cover}
          className=" rounded-[10px] object-cover w-full block"
          alt={data?.name}
          title={data?.name}
        />
        <div className="mt-3">
          <p className="text-[18px] font-[700]">{data?.name}</p>
          <p className="text-[12  px] text-[#5C5F5F] twoo_line">
            {data?.desc}{" "}
          </p>
          <Link
            to={"/blogs/" + data?.url}
            className="text-[#FFA800] font-bold"
          >
            بیشتر...
          </Link>
        </div>
      </Link>
    );
  }
  return (
    <Link to={"/blogs/" + data?.url} className="p-2">
      <div className="flex gap-3 items-center">
        <img
          src={CDN_BASE_URL + data?.cover}
          className="w-[65px] h-[65px] rounded-[10px] object-cover"
          alt={data?.name}
          title={data?.name}
        />
        <p className="text-[24px] font-[700]">{data?.name}</p>
      </div>
      <div className="mt-3">
        <p className="text-[14px] text-[#5C5F5F] three_line">{data?.desc}</p>
      </div>
    </Link>
  );
};

export default BlogCard;
